<fui-select-control
    [options]="options"
    [(value)]="selectedValue"
    (valueChange)="updateStateOnValueChange()"
    [disabled]="false"
    [labelField]="'label'"
    [label]="'fhm.control.venue-deployment-status-select.label'"
    [loading]="false"
    [placeholder]="' '"
    [valueField]="'value'"
    [internallyFilterable]="true"
    (removed$)="removed.emit()"
    [allowClearSelectionOption]="false"
    [showExtendedSearchOption]="false"
    [removable]="false"
    [showAddOption]="false">
</fui-select-control>
